import { AssessmentResponseSchema } from "@redotech/redo-model/return-assessments/assessment-schemas";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const completeAssessmentOnReturn = {
  name: "completeAssessmentOnReturn" as const,
  input: z.object({
    returnId: zExt.objectId(),
    productId: z.string(),
    definitionId: zExt.objectId(),
    responses: z.array(AssessmentResponseSchema),
    markCompleted: z.boolean().optional().default(true),
  }),
  output: z.object({
    success: z.boolean(),
    productAssessment: z.object({
      assessmentDefinitionId: zExt.objectId(),
      assignee: zExt.objectId().nullable().optional(),
      responses: z.array(AssessmentResponseSchema),
    }),
  }),
};
